import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=753d6924&lang=pug&"
import script from "./Warning.vue?vue&type=script&lang=js&"
export * from "./Warning.vue?vue&type=script&lang=js&"
import style0 from "./Warning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
